import React, { useState, createContext, useContext } from 'react';
import { User, Role } from '../types';
import { mockUsers } from '../data/mockData';
interface AuthContextType {
  currentUser: User | null;
  login: (email: string, role?: Role) => void;
  logout: () => void;
  switchRole: (role: Role) => void;
  isAuthenticated: boolean;
  isMaker: boolean;
  isChecker: boolean;
  isAdmin: boolean;
  isBranch: boolean;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const login = (email: string, role?: Role) => {
    // Mock login logic
    const user = mockUsers.find(u => u.email === email) || mockUsers[0];
    // If a specific role is requested (for demo purposes), override the user's role
    if (role) {
      setCurrentUser({
        ...user,
        role
      });
    } else {
      setCurrentUser(user);
    }
  };
  const logout = () => {
    setCurrentUser(null);
  };
  const switchRole = (role: Role) => {
    if (currentUser) {
      setCurrentUser({
        ...currentUser,
        role
      });
    }
  };
  const isMaker = currentUser?.role.includes('Maker') || false;
  const isChecker = currentUser?.role.includes('Checker') || false;
  const isAdmin = currentUser?.role.includes('Admin') || false;
  const isBranch = currentUser?.role.includes('Branch') || false;
  return <AuthContext.Provider value={{
    currentUser,
    login,
    logout,
    switchRole,
    isAuthenticated: !!currentUser,
    isMaker,
    isChecker,
    isAdmin,
    isBranch
  }} data-id="element-156">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}